// /**
//  * Custom Demo Request Form Handler
//  * Sends form data to your own API endpoint
//  */

// document.addEventListener("DOMContentLoaded", function () {
//   const form = document.getElementById("DemoRequestForm");

//   if (!form) return;

//   // Handle select placeholder styling
//   const selectElements = form.querySelectorAll("select");
//   selectElements.forEach((select) => {
//     // Set initial state
//     if (select.value === "") {
//       select.classList.add("placeholder");
//     }

//     // Update on change
//     select.addEventListener("change", function () {
//       if (this.value === "") {
//         this.classList.add("placeholder");
//       } else {
//         this.classList.remove("placeholder");
//       }
//     });
//   });

//   // Check for success after Shopify form submission
//   const urlParams = new URLSearchParams(window.location.search);
//   const customerPosted = urlParams.get("customer_posted");
//   const messageContainer = document.getElementById("demo-form-message");

//   if (customerPosted === "true" && messageContainer) {
//     // Show success message
//     showMessage(
//       messageContainer,
//       "success",
//       "Thank you! We'll get back to you within 1 business day.",
//     );

//     // Track conversion (Google Analytics, Facebook Pixel, etc.)
//     if (typeof gtag !== "undefined") {
//       gtag("event", "demo_request", {
//         event_category: "form",
//         event_label: "Demo Request Submitted",
//       });
//     }

//     // Clean URL
//     const newUrl = window.location.pathname + window.location.hash;
//     window.history.replaceState({}, document.title, newUrl);
//   }

//   // Add loading state on submit and populate note field
//   form.addEventListener("submit", function () {
//     // Collect all form data matching CreateDemoRequestDto structure
//     const formData = {
//       fullName: form.querySelector("#DemoFormName").value,
//       phone: form.querySelector("#DemoFormPhone").value,
//       workEmail: form.querySelector("#DemoFormEmail").value,
//       companyName: form.querySelector("#DemoFormCompany").value,
//       businessType: form.querySelector("#DemoFormBusinessType").value,
//       numberOfLocations: form.querySelector("#DemoFormLocations").value,
//       message: form.querySelector("#DemoFormMessage").value || "",
//       createdBy: "TMRWLABS Shopify Website Demo Request Form",
//     };

//     // Convert to JSON string and set in note field
//     const noteField = form.querySelector("#CustomerNote");
//     if (noteField) {
//       noteField.value = JSON.stringify(formData);
//     }

//     // Show loading state
//     const submitButton = form.querySelector('button[type="submit"]');
//     submitButton.disabled = true;
//     submitButton.textContent = "Sending...";
//   });
// });

// /**
//  * Display message to user
//  */
// function showMessage(container, type, message) {
//   container.style.display = "block";
//   container.className = `contact-form-message form-${type}-message`;
//   container.innerHTML = `<h3>${message}</h3>`;

//   // Scroll to message
//   container.scrollIntoView({ behavior: "smooth", block: "nearest" });

//   // Auto-hide after 5 seconds for success messages
//   if (type === "success") {
//     setTimeout(() => {
//       container.style.display = "none";
//     }, 5000);
//   }
// }

/**
 * Custom Demo Request Form Handler
 * Sends form data to your own API endpoint
 */

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("DemoRequestForm");

  if (!form) return;

  // Handle select placeholder styling
  const selectElements = form.querySelectorAll("select");
  selectElements.forEach((select) => {
    // Set initial state
    if (select.value === "") {
      select.classList.add("placeholder");
    }

    // Update on change
    select.addEventListener("change", function () {
      if (this.value === "") {
        this.classList.add("placeholder");
      } else {
        this.classList.remove("placeholder");
      }
    });
  });

  // Check for success after Shopify form submission
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get("customer_posted");

  if (customerPosted === "true") {
    // Get user email from URL params or localStorage
    const userEmail = urlParams.get("contact[email]") || localStorage.getItem("demoFormEmail") || "your@email.com";

    // Show success modal
    showSuccessModal(userEmail);

    // Track conversion (Google Analytics, Facebook Pixel, etc.)
    if (typeof gtag !== "undefined") {
      gtag("event", "demo_request", {
        event_category: "form",
        event_label: "Demo Request Submitted",
      });
    }

    // Clean URL
    const newUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }

  // Add loading state on submit and populate note field
  form.addEventListener("submit", function () {
    // Collect all form data matching CreateDemoRequestDto structure
    const formData = {
      fullName: form.querySelector("#DemoFormName").value,
      phone: form.querySelector("#DemoFormPhone").value,
      workEmail: form.querySelector("#DemoFormEmail").value,
      companyName: form.querySelector("#DemoFormCompany").value,
      businessType: form.querySelector("#DemoFormBusinessType").value,
      numberOfLocations: form.querySelector("#DemoFormLocations").value,
      message: form.querySelector("#DemoFormMessage").value || "",
      createdBy: "TMRWLABS Shopify Website Demo Request Form",
    };

    // Store email in localStorage for modal display after redirect
    localStorage.setItem("demoFormEmail", formData.workEmail);

    // Convert to JSON string and set in note field
    const noteField = form.querySelector("#CustomerNote");
    if (noteField) {
      noteField.value = JSON.stringify(formData);
    }

    // Show loading state
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.disabled = true;
    submitButton.textContent = "Sending...";
  });
});

/**
 * Show success modal with user email
 */
function showSuccessModal(email) {
  const modal = document.getElementById("demoSuccessModal");
  const emailElement = document.getElementById("modalUserEmail");

  if (!modal) return;

  // Set user email in modal
  if (emailElement) {
    emailElement.textContent = email;
  }

  // Show modal
  modal.style.display = "flex";

  // Prevent body scroll
  document.body.style.overflow = "hidden";

  // Setup close handlers
  setupModalCloseHandlers(modal);
}

/**
 * Setup modal close handlers
 */
function setupModalCloseHandlers(modal) {
  const closeButton = modal.querySelector(".demo-modal-close");
  const overlay = modal.querySelector(".demo-modal-overlay");

  // Close on X button click
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closeModal(modal);
    });
  }

  // Close on overlay click
  if (overlay) {
    overlay.addEventListener("click", function () {
      closeModal(modal);
    });
  }

  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.style.display === "flex") {
      closeModal(modal);
    }
  });
}

/**
 * Close modal
 */
function closeModal(modal) {
  modal.style.display = "none";
  document.body.style.overflow = "";

  // Clear stored email
  localStorage.removeItem("demoFormEmail");
}

